import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { redirectAfterAuth, hasPendingReviewReturn } from "@/lib/authRedirect";
import GoogleSignInButton from "@/components/site/GoogleSignInButton";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Selamat datang kembali");
      // Post-auth routing priority: pending transactional review intent >
      // new-user onboarding > default. Bypasses `/onboarding` when a guest
      // review submission is mid-flight so the ReviewWizard can auto-resume.
      if (hasPendingReviewReturn()) {
        redirectAfterAuth(nav);
      } else if (u && !u.onboarded) {
        nav("/onboarding", { replace: true });
      } else {
        redirectAfterAuth(nav);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal masuk");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-16">
      <div className="text-xs uppercase tracking-widest text-[#4B5563]">Selamat datang kembali</div>
      <h1 className="font-serif-display text-4xl text-[#1F2937] mt-2">Masuk</h1>
      <form onSubmit={submit} className="mt-8 space-y-3">
        <Input type="email" placeholder="Masukan email Anda" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="h-11 rounded-xl border-[#EAE7E0] bg-white" />
        <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="h-11 rounded-xl border-[#EAE7E0] bg-white" />
        <Button type="submit" disabled={busy} data-testid="login-submit" className="w-full h-11 rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF] text-white">{busy ? "Sedang masuk…" : "Masuk"}</Button>
      </form>

      <div className="my-6 flex items-center gap-3 text-xs uppercase tracking-widest text-[#4B5563]">
        <div className="h-px flex-1 bg-[#EAE7E0]" /> atau <div className="h-px flex-1 bg-[#EAE7E0]" />
      </div>
      <GoogleSignInButton text="signin_with" fallbackTo="/profile" testid="login-google" />

      <div className="mt-6 text-sm text-[#4B5563]">
        Baru di sini?{" "}
        <Link to="/register" className="text-[#1E3A8A] hover:text-[#E07A5F]" data-testid="link-register">Buat akun</Link>
      </div>
    </div>
  );
}
